




























import { Component, Prop } from 'vue-property-decorator';

import { mixins } from "vue-class-component";
import SharedMixin from "@/mixins/SharedMixin";

import { CustomerOrderStore } from '../../../store';

@Component({})
export default class PgaDeliverableCreate extends mixins(SharedMixin)
{
    @Prop({ default: -1, type: Number}) index!: number;

    get deliverableName() : string
    {
        return CustomerOrderStore.CustomerOrderCreate.Command.Deliverables[this.index]?.DeliverableName ?? "";
    }
    set deliverableName(value: string)
    {
        CustomerOrderStore.SET_CREATE_CUSTOMERORDER_DELIVERABLES_NAME({ index: this.index, deliverableName: value });
    }

    get deliveryBy() : Date
    {
        return CustomerOrderStore.CustomerOrderCreate.Command.Deliverables[this.index]?.DeliveryBy ?? new Date();
    }
    set deliveryBy(value: Date)
    {
        CustomerOrderStore.SET_CREATE_CUSTOMERORDER_DELIVERABLES_DATE({ index: this.index, deliveryBy: value });
    }

    private removeDeliverable() : void
    {
        CustomerOrderStore.REMOVE_CREATE_CUSTOMERORDER_DELIVERABLES(this.index);
    }
}
